export default __webpack_public_path__ + "static/media/usdc_poly.6f278e65.svg";